import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const patchSpecificChassisData = async ({ seq, data }) => {
  try {
    const response = await safetyDefaultAPI.patch(`chassis/${seq}`, data);

    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default patchSpecificChassisData;
